import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 22",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.5 18h27c.828 0 1.5.672 1.5 1.5v1c0 .828-.672 1.5-1.5 1.5h-27C.672 22 0 21.328 0 20.5v-1c0-.828.672-1.5 1.5-1.5z",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.5 9h27c.828 0 1.5.672 1.5 1.5v1c0 .828-.672 1.5-1.5 1.5h-27C.672 13 0 12.328 0 11.5v-1C0 9.672.672 9 1.5 9z",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.5 0h27c.828 0 1.5.672 1.5 1.5v1c0 .828-.672 1.5-1.5 1.5h-27C.672 4 0 3.328 0 2.5v-1C0 .672.672 0 1.5 0z",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }